import { render, staticRenderFns } from "./myStudentProductionEdit.vue?vue&type=template&id=1222a3a0&scoped=true&"
import script from "./myStudentProductionEdit.vue?vue&type=script&lang=js&"
export * from "./myStudentProductionEdit.vue?vue&type=script&lang=js&"
import style0 from "./myStudentProductionEdit.vue?vue&type=style&index=0&id=1222a3a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1222a3a0",
  null
  
)

export default component.exports